var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userId)?_c('div',{staticClass:"comment__user-profile-thum",style:(("background-image:url(/api/users/" + _vm.userId + "/avatar?random=" + (Math.floor(Math.random() * 100)) + ");"))}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }